import { useState } from "react";
import { CalendarPlus } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { api, errorMessage } from "@/lib/api";
import { track } from "@/lib/track";
import { to24, to12, startAt } from "@/lib/time";

const today = () => new Date().toLocaleDateString("en-CA");
const showTime = (item, day) => to24((item.schedule || []).find((s) => s.date === day)?.time);

export function AddToTrip({ item, city }) {
  const [day, setDay] = useState(today());
  const [time, setTime] = useState(showTime(item, today()));
  const [busy, setBusy] = useState(false);

  const changeDay = (d) => { setDay(d); const t = showTime(item, d); if (t) setTime(t); };

  const add = async () => {
    setBusy(true);
    try {
      await api.post("/itinerary", { city, day, time: to12(time), start_at: startAt(day, time), listing: item });
      track(item, "trip_add");
      toast.success("Added to your trip", { description: time ? `We'll remind you an hour before ${to12(time)}` : `${item.name} · ${day}` });
    } catch (e) { toast.error(errorMessage(e)); }
    finally { setBusy(false); }
  };

  return (
    <div className="rounded-2xl bg-[#0B0F19] border border-[#26334D] p-2 space-y-2">
      <div className="flex gap-2">
        <input data-testid="add-to-trip-date" type="date" value={day} min={today()} onChange={(e) => changeDay(e.target.value)}
          className="flex-1 min-w-0 bg-transparent px-2 text-sm outline-none [color-scheme:dark]" />
        <input data-testid="add-to-trip-time" type="time" value={time} onChange={(e) => setTime(e.target.value)}
          className="w-28 bg-transparent px-2 text-sm outline-none [color-scheme:dark]" />
      </div>
      <Button data-testid="add-to-trip-button" disabled={busy || !day} onClick={add}
        className="w-full rounded-xl bg-[#00E5A3] hover:bg-[#00C98F] text-[#0B0F19] font-semibold">
        <CalendarPlus className="h-4 w-4 mr-1.5" /> {busy ? "Adding…" : "Add to my trip"}
      </Button>
      <p className="text-[11px] text-slate-500 px-1">Add a time to get a reminder an hour before.</p>
    </div>
  );
}
